module.exports = __webpack_public_path__ + "static/media/alexander-dummer-UH-xs-FizTk-unsplash.a98c5527.jpg";